document.addEventListener('DOMContentLoaded', function () {

  function openTab(evt, tabName) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
      tablinks[i].setAttribute('aria-selected', false);
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "grid";
    evt.currentTarget.setAttribute('aria-selected', true);
    evt.currentTarget.className += " active";
  }

  // show the first tab and hide the rest
  document.getElementById('shaker-overview').style.display = "grid";
  document.getElementById('shaker-materials').style.display = "none";
  document.getElementById('shaker-colors').style.display = "none";

  document.getElementById('shaker-overview-button').addEventListener('click', (evt) => openTab(evt, 'shaker-overview'));
  document.getElementById('shaker-colors-button').addEventListener('click', (evt) => openTab(evt, 'shaker-colors'));
  document.getElementById('shaker-materials-button').addEventListener('click', (evt) => openTab(evt, 'shaker-materials'));
});

